import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import InstitutionMonitoringMain from './InstitutionMonitoringMain';
import Breadcrumb from '../../components/Breadcrumb';
import Logo from '../../assets/images/logos/logo2.png';
import Swal from 'sweetalert2';

const InstitutionMonitoring = () => {
    const navigate = useNavigate();
    const { exam_id } = useParams();

    const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#1e40af',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, logout'
        }).then((result) => {
            if (result.isConfirmed) {
            localStorage.removeItem('guest_user_role');
            localStorage.removeItem('guest_access_token');
            localStorage.removeItem('guest_refresh_token');
            localStorage.removeItem('guest_college_code');
            localStorage.removeItem('guest_college_name');
            sessionStorage.removeItem('guest_user_role');
            sessionStorage.removeItem('guest_college_code');
            sessionStorage.removeItem('guest_college_name');
            Swal.fire({
                title: 'Logged Out',
                text: 'You have successfully logged out.',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                confirmButtonColor: '#1e40af'
            }).then(() => {
                navigate('/login');
            });
            }
        });
    };

    return (
        <div className="institution-monitoring-page">
            <header className="header-area">
                <div className="menu-part" style={{ borderBottom: '1px solid #E8ECF4', background: '#fff' }}>
                    <div className="container">
                        <div style={{ padding: '14px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                            <Link to="/dashboard/institution" className="logo-text">
                                <img src={Logo} alt="Institution Logo" style={{ height: '55px' }} />
                            </Link>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                                <Link
                                    to="/dashboard/institution"
                                    className="react-btn-primary institution-header-action"
                                    style={{
                                        background: '#1e40af',
                                        border: '2px solid #1e3a8a',
                                        padding: '8px 20px',
                                        borderRadius: '8px',
                                        color: '#fff',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
                                        textDecoration: 'none',
                                        display: 'inline-block',
                                        textTransform: 'none'
                                    }}
                                >
                                    Back to Dashboard
                                </Link>
                                <button
                                    type="button"
                                    onClick={handleLogout}
                                    className="react-btn-primary institution-header-action"
                                    style={{
                                        background: '#1e40af',
                                        border: '2px solid #1e3a8a',
                                        padding: '8px 20px',
                                        borderRadius: '8px',
                                        color: '#fff',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
                                        textDecoration: 'none',
                                        display: 'inline-block',
                                        textTransform: 'none',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <style dangerouslySetInnerHTML={{ __html: `
                .institution-header-action {
                    transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
                    will-change: transform;
                }

                .institution-header-action:hover {
                    transform: translateY(-1px) scale(1.02);
                    filter: brightness(1.03);
                    box-shadow: 0 7px 14px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.35) !important;
                }

                .institution-header-action:active {
                    transform: translateY(0) scale(0.99);
                    filter: brightness(0.98);
                }
            `}} />
            <Breadcrumb pageTitle="Live Monitoring" />
            <div className="container mt-4 mb-5">
                <InstitutionMonitoringMain examId={exam_id} />
            </div>
        </div>
    );
};

export default InstitutionMonitoring;
